var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"bottom",rawName:"v-bottom",value:(_vm.nextPage),expression:"nextPage"}],staticClass:"videos-list"},[_vm._l((_vm.videosList),function(item,index){return _c('VideosCardH',{key:index,attrs:{"type":0,"videosInfo":item}})}),(_vm.endPage)?_c('div',{staticClass:"scroll-end"}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }